import React, { useContext, useMemo } from 'react';

import MetricCacheContext from 'contexts/MetricCacheContext';
import MetricsContext from 'contexts/MetricsContext';

const MetricsProvider = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const { normalMetricsCache } = useContext(MetricCacheContext);

  const allMetrics = useMemo(
    () => Array.from(normalMetricsCache.values()),
    [normalMetricsCache],
  );

  return (
    <MetricsContext.Provider
      value={{
        allMetrics,
        isLoading: false,
      }}
    >
      {children}
    </MetricsContext.Provider>
  );
};
export default MetricsProvider;
